import { useRef, useState, useCallback, useEffect } from "react";
import { IMAGES } from "../config";

export const BeforeAfterSlider = () => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const [w, setW] = useState(0);
  const dragging = useRef(false);

  useEffect(() => {
    const measure = () => ref.current && setW(ref.current.getBoundingClientRect().width);
    measure();
    window.addEventListener("resize", measure);
    return () => window.removeEventListener("resize", measure);
  }, []);

  const setFromClientX = useCallback((clientX) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    let pct = ((clientX - rect.left) / rect.width) * 100;
    pct = Math.max(2, Math.min(98, pct));
    setPos(pct);
  }, []);

  useEffect(() => {
    const move = (e) => {
      if (!dragging.current) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setFromClientX(clientX);
    };
    const up = () => (dragging.current = false);
    window.addEventListener("mousemove", move);
    window.addEventListener("touchmove", move, { passive: false });
    window.addEventListener("mouseup", up);
    window.addEventListener("touchend", up);
    return () => {
      window.removeEventListener("mousemove", move);
      window.removeEventListener("touchmove", move);
      window.removeEventListener("mouseup", up);
      window.removeEventListener("touchend", up);
    };
  }, [setFromClientX]);

  const start = (e) => {
    dragging.current = true;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    setFromClientX(clientX);
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      className="relative w-full aspect-[4/3] sm:aspect-[16/10] overflow-hidden rounded-[2rem] border border-[var(--border)] ambient-lg select-none cursor-ew-resize"
      onMouseDown={start}
      onTouchStart={start}
    >
      {/* AFTER (base) */}
      <img src={IMAGES.after} alt="Garden after weeding" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <span className="absolute bottom-4 right-4 z-20 rounded-full bg-white/90 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-[var(--forest)]">After</span>

      {/* BEFORE (clipped) */}
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={IMAGES.before}
          alt="Garden before weeding"
          className="absolute inset-0 h-full object-cover"
          style={{ width: w || "100%", maxWidth: "none" }}
          draggable={false}
        />
        <span className="absolute bottom-4 left-4 z-20 rounded-full bg-[var(--forest)]/90 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-white">Before</span>
      </div>

      {/* Handle */}
      <div className="absolute top-0 bottom-0 z-30 w-0.5 bg-white/90 pointer-events-none" style={{ left: `${pos}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full bg-white shadow-lg text-[var(--forest)]">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="m15 18-6-6 6-6"/></svg>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{ marginLeft: -6 }}><path d="m9 18 6-6-6-6"/></svg>
        </div>
      </div>
    </div>
  );
};
